import { ANALYTICS_EVENT_NAMES } from "analytics/catalog/events";
import { buildCommonEventProps } from "analytics/core/commonProps";
import { trackEvent } from "analytics/core/tracker";

export type VerificationAnalyticsContext = {
  pathname: string;
  search: string;
  businessId?: string | null;
  userId?: string | null;
  userEmail?: string | null;
  planType?: string | null;
  currency?: string | null;
};

const buildVerificationProps = (
  context: VerificationAnalyticsContext,
): Record<string, unknown> => {
  return buildCommonEventProps({
    screenKey: "verify_email",
    pathname: context.pathname,
    search: context.search,
    businessId: context.businessId ?? null,
    userId: context.userId ?? null,
    userEmail: context.userEmail ?? null,
    planType: context.planType ?? null,
    currency: context.currency ?? null,
  });
};

export const trackVerifyEmailPageViewed = (
  context: VerificationAnalyticsContext,
): void => {
  trackEvent(
    ANALYTICS_EVENT_NAMES.verifyEmailPageViewed,
    buildVerificationProps(context),
  );
};

export const trackVerificationConfirmClicked = (
  context: VerificationAnalyticsContext,
): void => {
  trackEvent(
    ANALYTICS_EVENT_NAMES.verificationConfirmClicked,
    buildVerificationProps(context),
  );
};

export const trackVerificationResendClicked = (
  context: VerificationAnalyticsContext,
): void => {
  trackEvent(
    ANALYTICS_EVENT_NAMES.verificationResendClicked,
    buildVerificationProps(context),
  );
};

export const trackVerificationSuccess = (
  context: VerificationAnalyticsContext,
): void => {
  trackEvent(ANALYTICS_EVENT_NAMES.verificationSuccess, buildVerificationProps(context));
};
